import React from 'react';
import AuthStore from '../stores/AuthStore';
import MultiAuctionStore from '../stores/MultiAuctionStore';
import MessageStore from '../stores/MessageStore';
import DataStore from '../stores/DataStore';
import UIStore from '../stores/UIStore';
import ProviderStore from '../stores/ProviderStore';
import VirtualAuctionStore from '../stores/VirtualAuctionStore';

// Instantiate stores
const authStore = new AuthStore();
const multiAuctionStore = new MultiAuctionStore();
const providerStore = new ProviderStore();
const virtualAuctionStore = new VirtualAuctionStore();
const messageStore = new MessageStore();

// BidStore instances will be managed by MultiAuctionStore
const dataStore = new DataStore(multiAuctionStore, authStore, providerStore, virtualAuctionStore);
const uiStore = new UIStore(dataStore, multiAuctionStore, virtualAuctionStore);

// Create context with MultiAuctionStore
const storesContext = React.createContext({
  AuthStore: authStore,
  MultiAuctionStore: multiAuctionStore,
  // MessageStore: messageStore,
  DataStore: dataStore,
  UIStore: uiStore,
  ProviderStore: providerStore,
  VirtualAuctionStore: virtualAuctionStore
});

export default storesContext;
